import { styled, alpha } from "@mui/material/styles";
import {
    Box as MuiBox
} from "@mui/material";

export const FeaturingLabelOverlayContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

export const CustomFeaturingLabelOverlay = styled(MuiBox)(({theme}) => ({
    alignSelf: "stretch",
    backgroundColor: `${alpha(theme.colors["indigo.450"], 0.75)}`,
    color: theme.colors["neutral.50"],
    display: "flex",
    flexDirection: "column",
    fontFamily: theme.fonts.default,
    fontSize: theme.fontSizes.lg,
    fontWeight: theme.fontWeights.bold,
    gap: theme.space._100,
    justifyContent: "flex-end",
    lineHeight: theme.lineHeights.slim,
    padding: `${theme.space._300} ${theme.space._500}`,
    width: "100%",

    "& > p": {
        fontFamily: theme.fonts.default,
        fontSize: theme.fontSizes.xs,
        fontWeight: theme.fontWeights.semibold,
        lineHeight: theme.lineHeights.slim
    }
}));